export default __webpack_public_path__ + "static/working-d8f3103e903a70db68f85099f2966e48.webp";